module.exports = __webpack_public_path__ + "static/img/main6_5.a8409b32.png";